// Texto da contagem regressiva do prazo de confirmação automática do reembolso
export const refundCountdownText = (expiresAt: string, now = Date.now()) => {
  const diff = new Date(expiresAt).getTime() - now
  if (Number.isNaN(diff) || diff <= 0) {
    return 'O prazo expirou; o reembolso será confirmado automaticamente em breve'
  }
  const totalMinutes = Math.floor(diff / 60000)
  const days = Math.floor(totalMinutes / 1440)
  const hours = Math.floor((totalMinutes % 1440) / 60)
  const minutes = totalMinutes % 60
  const parts: string[] = []
  if (days > 0) parts.push(`${days} ${days === 1 ? 'dia' : 'dias'}`)
  if (hours > 0) parts.push(`${hours} ${hours === 1 ? 'hora' : 'horas'}`)
  if (days === 0) {
    parts.push(`${minutes} ${minutes === 1 ? 'minuto' : 'minutos'}`)
  }
  return `O reembolso será confirmado automaticamente em ${parts.join(' e ')}`
}
